import { render, staticRenderFns } from "./tank-view-tasks-past.vue?vue&type=template&id=6858f2f2&"
import script from "./tank-view-tasks-past.vue?vue&type=script&lang=js&"
export * from "./tank-view-tasks-past.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports